import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'newlineToBr'
})
export class NewlineToBrPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) { }

    transform(value: string): SafeHtml {
        if (!value) {
            return '';
        }

        // Convert \n to <br> tags
        const htmlString = value.replace(/\n/g, '<br>');

        // Sanitize the HTML to prevent XSS attacks
        return this.sanitizer.bypassSecurityTrustHtml(htmlString);
    }
} 